import React from 'react';
import { Slot } from 'expo-router';
import { libraryKey } from '../../../constants/routeKeys';
import { title } from '../../../components/Root/title';



export default function Layout(){



  return (
    <Slot initialRouteName={libraryKey} screenOptions={({route}) => {
      return({
        headerShown: false,
        title: title(route.name),
      });}
    }/>
  );
}
